import { InvalidAddressError, isUTXOAddress } from '@bigmi/core';
export function getAddress(address) {
    if (!isUTXOAddress(address)) {
        throw new InvalidAddressError({ address });
    }
    return address;
}
//# sourceMappingURL=getAddress.js.map